/// <amd-module name="Artifacts/Root/components/FWLink" />
import * as React from "react";
import { ILinkProps, Link } from "VSSUI/Link";

export interface IFWLinkProps extends ILinkProps {
  linkId: string;
}

export const FWLink: React.FC<IFWLinkProps> = (props) => (
  <Link
    href={`https://go.microsoft.com/fwlink/?linkid=${props.linkId}`}
    {...props}
    target="_blank"
    rel="nofollow noreferrer noopener help"
    underline
  >
    {props.children}
  </Link>
);
